import React from 'react';
import { ButtonPrimary, dlsColorSuccess, IconSuccess } from '@americanexpress/dls-react';
import { FxJourneyCompletionPage, FxMultiButtons } from 'axp-fx-common';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RegisterLayout from '../Register/RegisterLayout';
import useAutoLogout from '../../hooks/useAutoLogout';

const SuccessMessage = ({ location }) => {
  const customMessage = location?.state?.successMessage;
  const heading = location?.state?.heading || 'Success!';
  const buttonLabel = location?.state?.buttonLabel || 'Login';
  const withBanner = location?.state?.withBanner;
  const appBaseUrl = useSelector((state) => state.getIn(['config', 'appBaseUrl']));
  const buttonHref = location?.state?.buttonHref || appBaseUrl;

  // When the CTA is a logout URL, silently log the user out after 10 seconds.
  useAutoLogout(buttonHref);

  const onNavigation = () => {
    window.location.href = buttonHref;
  };

  // Enrollment-completed flow — render inside the registration banner layout using
  // the shared FxJourneyCompletionPage (consistent with the other result pages).
  if (withBanner) {
    return (
      <RegisterLayout centerContent>
        <FxJourneyCompletionPage
          status="success"
          icon={<IconSuccess size="lg" theme={dlsColorSuccess} />}
          heading={heading}
          details={customMessage}
          actions={(
            <FxMultiButtons
              primaryButtonLabel={buttonLabel}
              onPrimaryButtonClick={onNavigation}
              justifyButtons="center"
            />
          )}
        />
      </RegisterLayout>
    );
  }

  return (
    <div className="border text-align-center pad-3-tb" role="status">
      <div className="pad-responsive-lr stack">
        <IconSuccess id="icon-success" size="xl" theme={dlsColorSuccess} />
        <h1 className="heading-4 margin-1-b">{heading}</h1>
        <p className="body-3">{customMessage || 'Your request has been completed successfully.'}</p>
      </div>
      <hr className="margin-3-tb" />
      <ButtonPrimary onClick={onNavigation}>{buttonLabel}</ButtonPrimary>
    </div>
  );
};

SuccessMessage.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      heading: PropTypes.string,
      successMessage: PropTypes.string,
      buttonLabel: PropTypes.string,
      buttonHref: PropTypes.string,
      withBanner: PropTypes.bool,
    }),
  }),
};

SuccessMessage.defaultProps = {
  location: undefined,
};

export default SuccessMessage;
